import React, { useContext, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Badge } from '@mantine/core';

import { FlexRow, Gap } from 'ui-components/components/flex';
import { AutomationRulesContext } from '../../../context';
import ActionEditor from './components/action-editor';
import messages from './messages';
import style from './style.module.less';

const RuleActions = () => {
  const intl = useIntl();
  const { selectedRule } = useContext(AutomationRulesContext);
  const { orderRuleActions } = selectedRule;
  const actions = useMemo(() => {
    return orderRuleActions.filter((action) => action && !action.isDeleted);
  }, [orderRuleActions]);

  return (
    <div className={style['automation-rule-actions']}>
      <FlexRow className={style['actions-header']} gap={Gap.Space8}>
        <Badge className={style['rule-badge']} color='neutral' size='sm' variant='outline'>
          {intl.formatMessage(messages.thenBadge)}
        </Badge>
        <FormattedMessage {...messages.actionsHeader} />
      </FlexRow>
      {actions.map((action) => {
        return <ActionEditor key={action.orderRuleActionId} orderRuleActionId={action.orderRuleActionId} />;
      })}
    </div>
  );
};

export default RuleActions;
